import { useEffect } from "react";

type Handlers = {
  onTab: (tab: "search" | "orders" | "dataEntry" | "forms" | "filmDrop") => void;
  currentTab: string;
  onQuickSearch: () => void;
  onAI: () => void;
  onEscape: () => void;
};

// Ported from the global keydown handler: S/O/D/R/F switch tabs, K quick-search
// (orders) else search tab, "/" AI, Esc closes modals. Disabled while typing.
export function useKeyboardShortcuts(h: Handlers) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const el = document.activeElement as HTMLElement | null;
      const typing =
        !!el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT" || el.isContentEditable);

      if (e.key === "Escape") {
        h.onEscape();
        return;
      }
      if (typing) return;
      if (e.metaKey || e.ctrlKey) return;

      switch (e.key.toLowerCase()) {
        case "s":
          e.preventDefault();
          h.onTab("search");
          break;
        case "o":
          e.preventDefault();
          h.onTab("orders");
          break;
        case "d":
          e.preventDefault();
          h.onTab("dataEntry");
          break;
        case "r":
          e.preventDefault();
          h.onTab("forms");
          break;
        case "f":
          e.preventDefault();
          h.onTab("filmDrop");
          break;
        case "k":
          e.preventDefault();
          if (h.currentTab === "orders") h.onQuickSearch();
          else h.onTab("search");
          break;
        case "/":
          e.preventDefault();
          h.onAI();
          break;
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [h]);
}
